if( window.console == null ){
    window.console = {
        log: function (p) {},
    };
}

var 
    _body,
    _window
;

var cfmv_FN = function(){
    cfmv = this;
    cfmv.init();
};

(function($){

    cfmv_FN.prototype = {

        percurseSameWay : 0,
        lastScrollTop : 0,
        lastSent : 'up',
        
        init: function(){

            _body = $( 'body' );
            _window = $( window );

            // Is admin page
            const isAdmin = _body.hasClass( 'wp-admin' );

            // Just frontend
            if( isAdmin ) return true;

            // Navigation
            cfmv.bindNavigation();

            // Sliders
            cfmv.bindSliders()
            cfmv.bindSwipers()

            // Função de resize da janela do browser ( Define qual o viewport )
            cfmv.resizing();
            window.onresize = cfmv.resizing;

            // General functions
            cfmv.general();

        },

        // Properties of Class
        properties: {
            timeEffects: 400, // Tempo para os efeitos
            device: 'desktop', // Device default
            loading: false,
            userbars: false,
        },

        bindNavigation : () => {

            // Header elements
            cfmv.header = document.querySelector( 'body > header' );
            if( cfmv.header ){

                cfmv.startPoint = cfmv.header.offsetHeight
                cfmv.checkScroll()
                
                window.addEventListener( 'scroll', cfmv.checkScroll )
            
            }
            
        },

        checkScroll(){

            // Top page positioun
            const scrollTop = Piki.getPageTop()
            
            // Direction
            var dir = scrollTop >= cfmv.lastScrolTop ? 'to-down' : 'to-up';
            if( dir === cfmv.lastDir && dir === 'to-down' ){

                const walked = ( scrollTop - cfmv.lastScrolTop )
                cfmv.walked += walked
                
                if( cfmv.walked >= 50 ){
                    //this.submenuClose()
                }
                
            }
            else {
                cfmv.walked = 0
            }

            if( cfmv.header ){

                // Sticky or not
                if( scrollTop >= cfmv.startPoint ){

                    cfmv.header.classList.add( 'sticky' )
                    cfmv.header.classList.remove( 'to-down', 'to-up' )
                    cfmv.header.classList.add( dir )
                
                } 
                else if( scrollTop === 0 ){
                    cfmv.header.classList.remove( 'sticky', 'to-down', 'to-up' )
                }

            }

            cfmv.lastDir = dir
            cfmv.lastScrolTop = scrollTop

        },

        bindSwipers : () => {
            
            // Not for mobile
            if( window.innerWidth <= 530 ) return true;

            const swips = document.querySelectorAll( '.swiper' )
            if( swips.length ){

                for( swip of swips ){

                    // Swiper
                    const pager = swip.querySelector( '.pagination' )
                    const prev = swip.querySelector( '.arrow.prev' )
                    const next = swip.querySelector( '.arrow.next' )

                    var swiper = new Swiper( swip, {
                        spaceBetween: 40,
                        slidesPerView: "auto",
                        preventInteractionOnTransition: true,
                        navigation: {
                            prevEl: prev,
                            nextEl: next,
                        },
                        pagination: {
                            el: pager,
                            clickable: true,
                        }
                    })
                    swiper.on( 'slideChange', ( swiper ) => {
                        const sent = swiper.previousIndex < swiper.realIndex ? 'to-right' : 'to-left';
                        pager.classList.remove( 'to-right', 'to-left' )
                        pager.classList.add( sent )
                    });

                }

            }

        },

        bindSliders : () => {

            const $mains = $( '.slider-wrapper' );
            if( !$mains.length ) return true;

            $mains.each(function(){

                this.$ = this.$ || $( this );

                // Is hero
                const isHero = this.$.data( 'is-hero' );

                // Slider
                const $slider = $( '.slider', this.$ );

                // Navigation
                let $nav = false
                const controlsLocation = this.$.data( 'controls-location' )
                if( controlsLocation && controlsLocation === 'parent' ){
                    $nav = $( '.slider-navigation', this.$.parent().parent() );
                }
                else {
                    $nav = $( '.slider-navigation', this.$ );
                }
                if( !$nav || !$nav.length ){
                    $nav = $( '#controls-' + this.id )
                }

                // Controls
                var $dots = $nav.find( '.dots' );
                var $prev = $nav.find( '.arrow-left' )
                var $next = $nav.find( '.arrow-right' )

                // Min width
                const minWidth = this.$.data( 'min-width' );
                if( minWidth && window.innerWidth < minWidth ){
                    if( $nav.length ){
                        $nav.remove()
                    }
                    return true;
                }

                // On init
                $slider.on( 'init', function( event, slick ){

                    if( slick?.$dots ){
                    
                        var $active = slick.$dots.children( 'li.slick-active' ).removeClass( 'slick-active' );
                        setTimeout(function(){
                            $active.addClass( 'slick-active' );
                        }, 1 );

                    }
                });
                const options = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true,
                    appendDots: $dots,
                    prevArrow: $prev,
                    nextArrow: $next,
                    infinite: false,
                    adaptiveHeight: true,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    pauseOnDotsHover: false,
                    autoplay: true,
                    autoplaySpeed: 8000,
                    customPaging: ( slider, i ) => {
                        return '<button><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.19045 6L12 2.19044L9.80956 3.82989e-07L3.80956 6L9.80956 12L12 9.80956L8.19045 6Z" fill="#181818"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.80956 6L3.82989e-07 2.19044L2.19044 -3.82989e-07L8.19044 6L2.19044 12L1.71516e-06 9.80956L3.80956 6Z" fill="#181818"/></svg></button>'
                    }
                }
                if( isHero ){
                    options.cssEase = 'linear'
                    options.infinite = true
                    options.fade = true
                    options.speed = 800
                }

                $slider.slick( options );

            });

        },

        // Função de resize da janela do browser ( Define qual o viewport )
        resizing: function () {
            
            var _wWidth = _window.outerWidth();

            // Define qual o viewport
            if( _wWidth < 768 ){
                cfmv.properties.device = 'smartphone';
            }
            else if ( _wWidth >= 768 && _wWidth <= 1279 ){
                cfmv.properties.device = 'tablet';
            }
            else { 
                cfmv.properties.device = 'desktop';
            }

            if ( cfmv.properties.device === 'desktop' ){
                _body
                    .removeClass( 'tablet' )
                    .removeClass( 'mobile' )
                    .addClass( 'desktop' )
                ;
            } 
            else if( cfmv.properties.device === 'tablet' ){
                _body
                    .removeClass( 'desktop' )
                    .removeClass( 'mobile' )
                    .addClass( 'tablet' )
                ;
            } 
            else if( cfmv.properties.device === 'smartphone' ){
                _body
                    .removeClass( 'desktop' )
                    .removeClass( 'tablet' )
                    .addClass( 'mobile' )
                ;
            }
        
        },

        // Funções gerais de todo o site
        general: function(){
        
            // Form cadastro
            _body.on( 'onChangeStep', 'form#cvpuser', function( e, data, step ){
                cfmv.signingLoginText = cfmv.signingLoginText || $( '.cadastro-login-text' );
                if( step === 'passo1' ){
                    cfmv.signingLoginText.fadeIn( 200 );
                }
                else {
                    cfmv.signingLoginText.fadeOut( 100 );
                }
            });

            // BG dots on signin form
            const $formUser = $( 'form#cvpuser.insert,form#forgotpass,form#resetpass' );
            if( $formUser.length ){
                $formUser.on( 'finish', () => {
                    $( 'body > main' ).addClass( 'bg-dots' );
                });
            }

            // Hide inline messages
            const message = $( 'body > main > .form-status' );
            if( message.length ){
                setTimeout(function(){
                    $( 'body>main' ).removeClass( 'with-status' );
                    message.css( 'display', 'absolute' ).slideUp(function(){ this.remove });
                }, 5000 );
            }
            
            // Accordion
            var $list = $( '.page-vencedores' );
            if( $list.length ){

                $( '.subcateg-label', $list ).on( 'click', function( event ){
                    
                    const _this = jQuery(this),
                    parent = _this.parent();

                    if( parent.hasClass( 'closed' ) ){
                        $( '> ul', parent ).slideDown( cfmv.properties.timeEffects );
                        parent.removeClass('closed');
                    } 
                    else {
                        event.preventDefault()
                        $( '> ul', parent ).slideUp( cfmv.properties.timeEffects );
                        parent.addClass( 'closed' );
                    }
                    
                });

            }

            // Selects
            $( 'select' ).each(function(){

                this.$ = this.$ || $( this );

                var options = { minimumResultsForSearch: -1 };
                if( this.$.hasClass( 'cidade' ) ){
                    options = {
                        "language": {
                            "noResults": function(){
                                return "Nenhum resultado";
                            }
                        },
                        escapeMarkup: function( markup ){
                            return markup;
                        }
                    };
                }

                //this.$.select2( options );
            
            });

        }

    };

    window.addEventListener( 'DOMContentLoaded', () => { 
        cfmv = new cfmv_FN();
    });
  
})(jQuery);
